import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Icon } from '@millionshow/client-libs';

interface SnsLink {
  name: string;
  url: string;
  icon: string;
}

@Component({
  selector: 'app-sns-buttons',
  imports: [CommonModule, Icon],
  templateUrl: './sns-buttons.component.html',
  standalone: true,
})
export class SnsButtonsComponent {
  snsLinks = input<SnsLink[]>([
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/best.expo/#',
      icon: 'simple-icons:instagram',
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@bestexpo',
      icon: 'simple-icons:youtube',
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/goodspace.expo',
      icon: 'simple-icons:facebook',
    },
    {
      name: 'Blog',
      url: 'https://blog.naver.com/good-space',
      icon: '/home/blog.svg',
    },
  ]);
}
